import { Content, ProductError, ProductErrorType } from '../../models';
import { v4 as uuidv4 } from 'uuid';
export class AccordionData {
  items: AccordionItem[];

  constructor(accordion?: AccordionData) {
    this.items = accordion?.items?.map(item => new AccordionItem(item)) || [];
  }

  static validate(accordion: AccordionData, payloadData: any): ProductError[] {
    const errors: ProductError[] = [];

    if (!accordion.items || !accordion.items.length) {
      errors.push({ type: ProductErrorType.MISSING, property: 'items', payload: { ...payloadData } });
    }

    errors.push(
      ...accordion.items.flatMap((item, itemIndex) => AccordionItem.validate(item, { ...payloadData, itemIndex })),
    );

    return errors;
  }
}

export class AccordionItem {
  uuid: string;
  title: string;
  contents: Content[];
  isOpenByDefault: boolean;

  constructor(item?: AccordionItem) {
    this.uuid = item?.uuid ?? uuidv4();
    this.title = item?.title ?? null;
    this.contents = item?.contents?.map(c => new Content(c)) ?? null;
    this.isOpenByDefault = item?.isOpenByDefault ?? false;
  }

  static validate(item: AccordionItem, payloadData: any): ProductError[] {
    const errors: ProductError[] = [];

    errors.push(
      ...ProductError.validatePrimitiveTypes(item, ['title', 'uuid'], []).map(error => ({
        ...error,
        payload: { ...payloadData },
      })),
    );

    if (!item.contents || !item.contents.length) {
      errors.push({ type: ProductErrorType.MISSING, property: 'contents', payload: { ...payloadData } });
    }
    item.contents
      ?.map((c, i) => Content.validate(c, i, { ...payloadData }))
      .reduce((flattened, subError) => flattened.concat(subError), [])
      .forEach(error => {
        errors.push(error);
      });

    return errors;
  }
}

export class AccordionProgression {
  accordionProgressionList: AccordionProgressionItem[];

  constructor(progression?: AccordionProgression) {
    this.accordionProgressionList = (progression?.accordionProgressionList || []) //
      .map(v => new AccordionProgressionItem(v));
  }
}

export class AccordionProgressionItem {
  itemUuid: string;

  constructor(accordionProgression: AccordionProgressionItem) {
    this.itemUuid = accordionProgression.itemUuid;
  }
}
